// Cygnus icon as a raw HTML string, for non-Vue contexts that build markup
// by hand (tabulator cell formatters, innerHTML assignments, tabulator config
// element strings). Vue components should use <CygnusIcon> instead.
//
// The returned <svg><use> references the Cygnus sprite injected into the
// document by the first mounted <CygnusIcon>; this helper also calls
// injectSprite() defensively so a formatter that renders before any icon
// component still resolves.
import injectSprite from '@apexl/icarus-core/src/services/icons/injectSprite.mjs';
import resolveIconName from '@apexl/icarus-core/src/services/icons/resolveIconName.mjs';

/**
 * @param {string} name    Cygnus base name (or any FA-era name resolveIconName handles).
 * @param {object} [opts]
 * @param {'light'|'solid'} [opts.variant='light']
 * @param {string} [opts.className='']  extra classes (e.g. 'me-1 text-success')
 * @param {string} [opts.title='']      tooltip / a11y label
 * @param {boolean} [opts.spin=false]
 * @returns {string} inline <svg> markup, or '' if the name doesn't resolve
 */
export default function cygnusSpriteHtml(name, opts = {}) {
  injectSprite();
  const resolved = resolveIconName(name);
  if (!resolved) return '';
  const { variant = 'light', className = '', title = '', spin = false } = opts;
  const w = variant === 'solid' ? 's' : 'l';
  const cls = ['cygnus-icon', spin ? 'cygnus-icon--spin' : '', className]
    .filter(Boolean).join(' ');
  const ttl = title ? `<title>${title}</title>` : '';
  return `<svg class="${cls}" width="1em" height="1em" viewBox="0 0 24 24" `
    + `aria-hidden="true" focusable="false">${ttl}<use href="#i-${resolved}-${w}"></use></svg>`;
}
